// import * as L from "leaflet";
// import "leaflet/dist/leaflet.css";
// import { useEffect, useRef } from "react";
// import { MapContainer, TileLayer, Polygon, Marker, Polyline, Popup } from "react-leaflet";

// export const OliveProjectGeometry = ({ FarmData }) => {
//   console.log("FarmData",FarmData)
//   const geometryType = FarmData?.geom?.geometry?.type;
//   const coords = FarmData?.geom?.geometry?.coordinates;
//   const geomType = FarmData?.geom?.properties?.geom_type;

//   const mapRef = useRef(null);

//   const toLatLng = (c) => [c[1], c[0]];

//   let shape = null;
//   let bounds = [];

//   if (geometryType === "Polygon") {
//     shape = coords[0].map(toLatLng);
//     bounds = shape;
//   }

//   if (geometryType === "MultiPolygon") {
//     shape = coords.map((poly) => poly[0].map(toLatLng));
//     bounds = shape[0]; 
//   }

//   if (geometryType === "MultiPoint") {
//     shape = coords.map(toLatLng);
//     bounds = shape;
//   }

//   if (geometryType === "Point") {
//     shape = toLatLng(coords);
//     bounds = [shape];
//   }

//   if (geometryType === "LineString") {
//     shape = coords.map(toLatLng);
//     bounds = shape;
//   }

//   useEffect(() => {
//     if (mapRef.current && bounds.length > 0) {
//       const map = mapRef.current;
//       map.fitBounds(bounds, { padding: [40, 40] });
//     }
//   }, [bounds]);

//   return (
//     <MapContainer
//       ref={mapRef}
//       center={[39.55, -7.85]}  
//       zoom={6}
//       style={{ height: "44vh", width: "100%" }}
//     >
//       <TileLayer
//         url="http://mt0.google.com/vt/lyrs=y&hl=en&x={x}&y={y}&z={z}"
//       />

//       {geometryType === "Polygon" && (
//         <Polygon positions={shape} pathOptions={{ color: "blue" }}>
//           <Popup><b>{geomType}</b> – Polygon</Popup>
//         </Polygon>
//       )}

//       {geometryType === "MultiPolygon" && (
//         <Polygon positions={shape} pathOptions={{ color: "purple" }}>
//           <Popup><b>{geomType}</b> – MultiPolygon</Popup>
//         </Polygon>
//       )}

//       {geometryType === "MultiPoint" &&
//         shape.map((p, i) => (
//           <Marker key={i} position={p}>
//             <Popup><b>{geomType}</b> – Point {i + 1}</Popup>
//           </Marker>
//         ))
//       }

//       {geometryType === "Point" && (
//         <Marker position={shape}>
//           <Popup><b>{geomType}</b> – Point</Popup>
//         </Marker>
//       )}

//       {geometryType === "LineString" && (
//         <Polyline positions={shape} pathOptions={{ color: "green" }}>
//           <Popup><b>{geomType}</b> – LineString</Popup>
//         </Polyline>
//       )}
//     </MapContainer>
//   );
// };
import * as L from "leaflet";
import "leaflet/dist/leaflet.css";
import { useEffect, useRef } from "react";
import { MapContainer, TileLayer, Polygon, Marker, Polyline, Popup } from "react-leaflet";

export const OliveProjectGeometry = ({ FarmData }) => {

  const geometryType = FarmData?.geom?.geometry?.type || null;
  let coords = FarmData?.geom?.geometry?.coordinates || [];
  const geomType = FarmData?.geom?.properties?.geom_type || "Geometry";

  const mapRef = useRef(null);
  const toLatLng = (c) => Array.isArray(c) && c.length >= 2 ? [c[1], c[0]] : null;

  let shape = null;
  let bounds = [];

  /* ------------------------------------------------------------------
     SAFE NORMALIZATION SECTION (Fix MultiPoint nested structure)
  --------------------------------------------------------------------*/

  if (geometryType === "MultiPoint") {
    // If backend sends [[[lon,lat],[lon,lat]]] → flatten safely
    if (coords.length === 1 && Array.isArray(coords[0][0])) {
      coords = coords[0];
    }
    shape = coords.map(toLatLng).filter(Boolean);
    bounds = shape;
  }

  if (geometryType === "Point") {
    shape = toLatLng(coords);
    shape && bounds.push(shape);
  }

  if (geometryType === "Polygon") {
    if (Array.isArray(coords[0])) {
      shape = coords[0].map(toLatLng).filter(Boolean);
      bounds = shape;
    }
  }

  if (geometryType === "MultiPolygon") {
    shape = coords.map(poly =>
      Array.isArray(poly[0]) ? poly[0].map(toLatLng).filter(Boolean) : []
    );
    bounds = shape[0] || [];
  }

  if (geometryType === "LineString") {
    shape = coords.map(toLatLng).filter(Boolean);
    bounds = shape;
  }

  /* ------------------------------------------------------------------
     FIT BOUNDS SAFELY
  --------------------------------------------------------------------*/

  useEffect(() => {
    if (mapRef.current && bounds.length > 0) {
      try {
        mapRef.current.fitBounds(bounds, { padding: [40, 40] });
      } catch (e) {
        console.warn("fitBounds failed:", e);
      }
    }
  }, [JSON.stringify(bounds)]);

  /* ------------------------------------------------------------------
     RENDER
  --------------------------------------------------------------------*/

  return (
    <MapContainer
      ref={mapRef}
      center={[39.55, -7.85]}
      zoom={5}
      style={{ height: "44vh", width: "100%" }}
    >
      <TileLayer url="http://mt0.google.com/vt/lyrs=y&hl=en&x={x}&y={y}&z={z}" />

      {/* Polygon */}
      {geometryType === "Polygon" && shape && (
        <Polygon positions={shape} pathOptions={{ color: "blue" }}>
          <Popup>{geomType} – Polygon</Popup>
        </Polygon>
      )}

      {/* MultiPolygon */}
      {geometryType === "MultiPolygon" && shape && (
        <Polygon positions={shape} pathOptions={{ color: "purple" }}>
          <Popup>{geomType} – MultiPolygon</Popup>
        </Polygon>
      )}

      {/* MultiPoint */}
      {geometryType === "MultiPoint" &&
        shape?.map((p, i) => (
          <Marker key={i} position={p}>
            <Popup>{geomType} – Point {i + 1}</Popup>
          </Marker>
        ))}

      {/* Single Point */}
      {geometryType === "Point" && shape && (
        <Marker position={shape}>
          <Popup>{geomType} – Point</Popup>
        </Marker>
      )}

      {/* LineString */}
      {geometryType === "LineString" && shape && (
        <Polyline positions={shape} pathOptions={{ color: "green" }}>
          <Popup>{geomType} – LineString</Popup>
        </Polyline>
      )}
    </MapContainer>
  );
};
